export default __webpack_public_path__ + "static/media/inbox-active.68a6cdf8.svg";